import './loadingSpinner.less';

type LoadingSpinnerProps = {
	size?: LoadingSpinnerSize;
};

export enum LoadingSpinnerSize {
	xlarge = 100,
	large = 75,
	medium = 50,
	small = 30,
	xssmall = 18,
}

export default function LoadingSpinner({
	size = LoadingSpinnerSize.xssmall,
}: LoadingSpinnerProps) {
	return (
		<div className="loading-spinner" style={{ width: size, height: size }}>
			<div className="icon-community" style={{ fontSize: size }} />
		</div>
	);
}
